module.exports = __webpack_public_path__ + "static/media/2.14b7e1aa.JPG";